export const COUNTRIES = ['United States', 'India'] as const;

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming',
];

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa',
  'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala',
  'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland',
  'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir',
  'Ladakh', 'Lakshadweep', 'Puducherry',
];

export const normalizeCountry = (country?: string | null): string => {
  const value = (country || '').trim().toLowerCase();
  if (['india', 'in', 'bharat'].includes(value)) return 'India';
  if (['united states', 'united states of america', 'usa', 'us', 'america'].includes(value)) {
    return 'United States';
  }
  return (country || '').trim();
};

export const getStatesForCountry = (country?: string | null): string[] => {
  const normalized = normalizeCountry(country);
  if (normalized === 'India') return INDIAN_STATES;
  if (normalized === 'United States') return US_STATES;
  return [];
};

export const hasPresetStates = (country?: string | null): boolean =>
  getStatesForCountry(country).length > 0;

export const getPostalCodeLabel = (country?: string | null): string =>
  normalizeCountry(country) === 'India' ? 'PIN Code' : 'ZIP Code';

export const getCountryOptions = (currentCountry?: string | null): string[] => {
  const normalized = normalizeCountry(currentCountry);
  if (normalized && !COUNTRIES.includes(normalized as (typeof COUNTRIES)[number])) {
    return [normalized, ...COUNTRIES];
  }
  return [...COUNTRIES];
};

export const getStateOptions = (country?: string | null, currentState?: string | null): string[] => {
  const states = getStatesForCountry(country);
  const current = (currentState || '').trim();
  if (current && !states.includes(current)) {
    return [current, ...states];
  }
  return states;
};
